import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';

import { i18n } from '@/utils/i18n';

// Amenity
const amenitySchema = Yup.object().shape({
  id: Yup.string(),
  title: Yup.string().required(i18n.t('profile.create_form.validations.name_required')),
  nonProfitOrgId: Yup.string()
});

// Amenitties
const amenitiesSchema = Yup.object().shape({
  amenities: Yup.array()
    .of(amenitySchema)
    .min(1, i18n.t('profile.create_form.validations.min_amenities_to_submit'))
    .required()
});

// Types
export type AmenitiesData = Yup.InferType<typeof amenitiesSchema>;
export type AmenityData = Yup.InferType<typeof amenitySchema>;

// Resolvers
export const amenitiesResolver = yupResolver(amenitiesSchema);
export const amenityResolver = yupResolver(amenitySchema);
